import React, { useMemo } from "react";
import "./style.scss";
import { ApplicationData } from "../../../types/sponsorships/campaigns";
import ProBadge from "../../../assets/icons/ProBadge";
import { Link } from "react-router-dom";
import { FREE_SUBSCRIPTION_PLAN_ID } from "../../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux-stores/store";
import { setProFeaturesModalVisibility } from "../../../redux-stores/slices/layoutSlice";


type Props = {
  applicationData: ApplicationData | null;
  onSeeHowClick?: () => void;
  onUpgradeClick?: () => void;
};

const clampPercent = (value: number) => Math.max(0, Math.min(100, value));

const GetProSubscriptionCard: React.FC<Props> = ({ applicationData, onUpgradeClick }) => {

    const activePlan = useSelector((state: RootState) => state.influencer.active_plan);
    const dispatch:AppDispatch = useDispatch();
    const stats = useMemo(() => {
    const current = clampPercent(applicationData?.acceptance_probability?.current ?? 0);
    const pro = clampPercent(applicationData?.acceptance_probability?.pro ?? 0);

    return {
      seatLeft: applicationData?.seat_left ?? 0,
      applicationCount: applicationData?.application_count ?? 0,
      current,
      pro,
    };
  }, [applicationData]);

  if(!applicationData?.upgrade_to_pro) return null;

  return (
    <div className="get-pro-subscription-card" data-node-id="1546:12561">
      <div className="gpsc__content">
        <div className="gpsc__body">
          <div className="gpsc__top">
            <div className="gpsc__badge" data-node-id="1546:12565">
              <span className="gpsc__badgeIcon" aria-hidden="true">
                <ProBadge />
              </span>
              <span className="fs-12 fw-400 text-dark gpsc__badgeLabel">BECOME</span>
              <span className="fs-12 fw-700 gpsc__badgePro">PRO</span>
            </div>

            <div className="gpsc__title text-dark fw-700" data-node-id="1546:12570">
            <div>Increase your chances of getting selected!</div>
              {/* <div>Increase your chances</div>
              <div>
                of getting selected <span>from</span> {stats.current}% → <span className="gpsc__titleGreen">{stats.pro}%</span>
              </div> */}
            </div>

            {/* <div className="gpsc__subline fs-12 fw-400" data-node-id="1546:12571">
              <span className="text-dark-gray">Only {stats.seatLeft} Seats Left</span>
              <span className="text-muted"> • {stats.applicationCount} Applications</span>
            </div> */}
          </div>

          <div className="gpsc__mid">
            {/* <div className="gpsc__comparison" data-node-id="1546:12573">
              <div className="gpsc__comparisonRow">
                <span className="gpsc__comparisonLabel fs-14 fw-400 text-dark">Free</span>
                <span className="gpsc__bar gpsc__bar--free" aria-hidden="true">
                  <span className="gpsc__barFill gpsc__barFill--free" style={{ width: `${stats.current}%` }} />
                </span>
                <span className="gpsc__comparisonValue fs-14 fw-400 text-dark">{stats.current}%</span>
              </div>

              <div className="gpsc__comparisonRow">
                <span className="gpsc__comparisonLabel fs-14 fw-400 text-dark">Pro</span>
                <span className="gpsc__bar gpsc__bar--pro" aria-hidden="true">
                  <span className="gpsc__barFill gpsc__barFill--pro" style={{ width: `${stats.pro}%` }} />
                </span>
                <span className="gpsc__comparisonValue fs-14 fw-600 text-success">{stats.pro}%</span>
              </div>
            </div> */}

            <button className="gpsc__seeHow fs-14 fw-500" type="button" onClick={() => {
                dispatch(setProFeaturesModalVisibility(true));
            }} data-node-id="1546:12585">
              See How?
            </button>
          </div>
        </div>

        <Link to={{ pathname: activePlan?.plan?.id === FREE_SUBSCRIPTION_PLAN_ID ? "/subscription-plans" : "/subscription" }} className="gpsc__cta" type="button" onClick={onUpgradeClick} data-node-id="1546:12586">
            <span className="gpsc__ctaText fs-14 fw-600">UPGRADE TO PRO</span>
        </Link>
      </div>
    </div>
  );
};

export default GetProSubscriptionCard;